function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 20V10",
  stroke: "#008C85",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 20V4",
  stroke: "#008C85",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6 20V14",
  stroke: "#008C85",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.6cbda4c15daba90961800a6ee40443cf.svg";
export { ForwardRef as ReactComponent };